import React, { useState } from "react";
import { useDispatch } from "react-redux";
import {
  AddButton,
  BackButton,
  ThinDropdown,
  ThinTextField,
} from "../../common/GeneralComponent";
import { fetchData } from "../../../utils/functions";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Link, useNavigate } from "react-router-dom";
import { ChevronFirstIcon } from "lucide-react";

const AddProvinces = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const formik = useFormik({
    initialValues: {
      name: "",
      status: 1,
    },
    validationSchema: Yup.object({
      name: Yup.string()
        .required("Province Name is required")
        .matches(
          /^[a-zA-Z\s]+$/,
          "Province Name cannot contain Special Characters or Number"
        )
        .min(3, "Province Name must be at least 3 characters long")
        .max(50, "Province Name must be at most 50 characters long"),
      status: Yup.string().required("Status is required"),
    }),
    onSubmit: async (values) => {

      const data = {
        Province: values.name,
        status: values.status === 1 ? 1 : 0,
      };

      try {

        const response = await fetchData("provinces", "POST", data);
        toast.success("Created Successfully");
        navigate("/provinces");
      } catch (error) {
        toast.error(error.message);
      }
    },
  });

  return (
    <div  className="w-full my-4 mx-auto">
   
    
 <div className="flex  lg:flex-row flex-col lg:justify-between justify-start lg:items-center items-start gap-3 w-full">
    <h1 className="lg:text-[1.475rem] text-[1rem] text-[#212529] font-[Bold]">
                Create Province
             </h1>
    <BackButton text="Back" to="/provinces" />
         </div>

      <div className="bg-white rounded-lg shadow w-full lg:mb-[30px] mt-4  mb-[7rem]">
        
           <div  className="p-4 flex md:flex-row rounded-t-lg gradiant2 flex-col gap-3 justify-between md:items-center border-lightGray border-b ">
         <h1  className="lg:text-[0.875rem] text-[13px]  tracking-[0.0625rem] text-[#856800] font-[bold] uppercase">
            Create Province
          </h1>
        
        </div>
        <form onSubmit={formik.handleSubmit}  className="p-4">
          <div className="flex lg:flex-nowrap flex-wrap  gap-5 ">
            <ThinTextField
              id="name"
              label="Province Name"
              placeholder="Sindh"
              type="text"
              value={formik.values.name}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.name && formik.errors.name}
              helperText={formik.touched.name && formik.errors.name}
            />
            <ThinDropdown
              label="Status"
              id="status-dropdown"
              options={[
                { value: 1, label: "Active" },
                { value: 0, label: "In-Active" },
              ]}
              value={formik.values.status}
              onChange={(e) =>
                formik.setFieldValue("status", Number(e.target.value))
              }
              onBlur={formik.handleBlur}
              error={formik.touched.status && formik.errors.status}
              helperText={formik.touched.status && formik.errors.status}
            />
          </div>
          <div className="p-4">
            <AddButton text="Submit" type="Submit" isLoading={isSubmitting} />
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddProvinces;
